import { render, staticRenderFns } from "./objectsAgentDialog copy.vue?vue&type=template&id=cdec6e32&"
import script from "./objectsAgentDialog copy.vue?vue&type=script&lang=js&"
export * from "./objectsAgentDialog copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports